import { getCustomers, getPersonalName } from "src/services/utils";

export const getFeedbackText = (comment) => {
    const personalName = getPersonalName();
    const { selectedCustomer = null } = getCustomers();
    const feedbackText = `${comment} -- ${personalName}  Customer #: ${selectedCustomer?.customer_number}`;
    return feedbackText;
};
